import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import data22 from '../../data/data22.json'
import ArticleList from '../../Components/ArticleList';

import person4 from '../../static/person4.webp'
import person5 from '../../static/person5.webp'
import person6 from '../../static/person6.webp'



const BoardMembers: React.FC = () => {
    const history = useHistory();


    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>理事会、监事会成员信息</h1>
                <div className='members-carousel'>
                    <Slider dots infinite speed={500} slidesToShow={1} slidesToScroll={1} autoplay={true} autoplaySpeed={2000}>
                        <div className='member-card'>
                            <img src={person4} alt='人物1' className='member-photo' />
                            <h1>刘  虹</h1>
                            <h5>理事长</h5>
                            <p>杭州市西湖区绿城爱心基金会理事长、郁金香陪伴创始人、国家二级心理咨询师。</p>
                        </div>
                        <div className='member-card'>
                            <img src={person5} alt='人物2' className='member-photo' />
                            <h1>尚书臣</h1>
                            <h5>副理事长</h5>
                            <p>曾任绿城中国董事会秘书（经营班子成员）、兼任董事会办公室主任、总裁办公室主任、党群办公室主任。尚先生毕业于辽宁青年管理干部学院、沈阳农业大学，拥有硕士学位。尚先生曾任辽宁省庄河市团委书记、工会主席、纪委书记、市委副书记、市政府常务副市长，大连循环产业经济区党工委副书记、管委会副主任，大连市委组织部副部长，大连金普新区党工委委员、管委会副主任兼大连金石滩国家旅游度假区党组书记、管委会主任等职务，在组织建设、干部和人才管理、行政管理等方面拥有丰富的经验。尚先生于2019年4月加入绿城集团，获委任为党群办公室主任，于2019年12月16日获委任为董事会办公室主任（兼）、总裁办公室主任（兼），于2020年3月20日获委任为绿城中国董事会秘书、杭州市西湖区绿城爱心基金会副理事长。</p>
                        </div>
                        <div className='member-card'>
                            <img src={person6} alt='人物3' className='member-photo' />
                            <h1>何季颖</h1>
                            <h5>秘书长</h5>
                            <p>杭州市西湖区绿城爱心基金会秘书长、杭州郁金香助医公益服务中心负责人、郁金香《和你有约》主持人、艺术治疗师、亲子教育专家、婚姻情感关系专家。</p>
                        </div>
                    </Slider>
                </div>
                <div className='members-info'>
                    <h2 className='section-title'>成员信息</h2>
                    <div className='info-card'>
                        <h3>理事长</h3>
                        <h5>刘虹</h5>
                        <p>杭州市西湖区绿城爱心基金会理事长、郁金香陪伴创始人、国家二级心理咨询师。</p>
                    </div>
                    <div className='info-card'>
                        <h3>副理事长</h3>
                        <h5>尚书臣</h5>
                        <p>曾任绿城中国董事会秘书（经营班子成员）、兼任董事会办公室主任、总裁办公室主任、党群办公室主任。尚先生毕业于辽宁青年管理干部学院、沈阳农业大学，拥有硕士学位。尚先生曾任辽宁省庄河市团委书记、工会主席、纪委书记、市委副书记、市政府常务副市长，大连循环产业经济区党工委副书记、管委会副主任，大连市委组织部副部长，大连金普新区党工委委员、管委会副主任兼大连金石滩国家旅游度假区党组书记、管委会主任等职务，在组织建设、干部和人才管理、行政管理等方面拥有丰富的经验。尚先生于2019年4月加入绿城集团，获委任为党群办公室主任，于2019年12月16日获委任为董事会办公室主任（兼）、总裁办公室主任（兼），于2020年3月20日获委任为绿城中国董事会秘书、杭州市西湖区绿城爱心基金会副理事长。</p>
                    </div>
                    <div className='info-card'>
                        <h3>秘书长</h3>
                        <h5>何季颖</h5>
                        <p>杭州市西湖区绿城爱心基金会秘书长、杭州郁金香助医公益服务中心负责人、郁金香《和你有约》主持人、艺术治疗师、亲子教育专家、婚姻情感关系专家。</p>
                    </div>
                    <div className='info-card'>
                        <h3>理事</h3>
                        <h5>嵇 哲</h5>
                        <p>绿城中国董办、党群办副主任</p>
                        <h5>李小洁</h5>
                        <p>绿城中国党群管理专业总监</p>
                        <h5>陈红伟</h5>
                        <p>绿城中国财务资金中心总经理</p>
                        <h5>傅春胜</h5>
                        <p>中科博爱(北京)心理医学研究院院长、中国生命关怀协会婚姻与家庭专业委员会主任、静观专委会主任、中国心理学会心理服务机构工作委员会副主任，中国心理卫生协会特群委员会常务委员，中国社工联合会城乡社区工作委员会副主任，中国生命关怀协会感觉统合专业委员会主任，中国残疾康复协会心理健康专业委员会常务委员、中华志愿者协会社会心理服务项目办公室主任、北京十分老年身心康养理疗中心创始人。</p>
                        <h5>杨轶清</h5>
                        <p>浙江省重点智库浙江工商大学浙商研究院(中国华商研究院)执行院长、浙商博物馆馆长，兼任长三角民营经济研究会副会长、浙江省浙商研究会执行会长、浙江省统战理论研究会副会长、浙江省国际经济交流协会副会长、浙商总会学术委员会秘书长，浙江省工商联执委和浙商总会理事会成员。</p>
                        <h5>夏宏炜</h5>
                        <p>浙报传媒城市更新智库主理人，曾担任浙江日报传媒有限公司大地产媒体中心副主任、浙江日报新闻发展有限公司浙江地产事业部主任，长期从事房地产行业研究。</p>
                    </div>
                    <div className='info-card'>
                        <h3>监事</h3>
                        <h5>张 聪</h5>
                        <p>绿城中国党群办党群管理专业副总监</p>
                        <p>高级人力资源管理师、中级经济师、绿城大学认证讲师、认证导师。</p>
                    </div>
                </div>
                <ArticleList dataId="22" data={data22 as any} />
            </div>
        } />
    );
};

export default BoardMembers;